import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faDoorOpen,
  faPencilRuler,
  faImages,
  faAlignJustify,
  faFileImport,
  faCogs,
} from "@fortawesome/free-solid-svg-icons";

const getIcon = (name) => {
  switch (name) {
    case "door-open":
      return faDoorOpen;
    case "images":
      return faImages;
    case "pencil":
      return faPencilRuler;
    case "justify":
      return faAlignJustify;
    case "import":
      return faFileImport;
    case "cogs":
      return faCogs;
    default:
      return null;
  }
};

const ModalIconLink = (props) => {
  if (!props.onClick) return null;

  const clickAndBlur = (e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
      e.target.blur();
    }

    props.onClick();
  };

  return (
    <a
      href="#"
      onClick={clickAndBlur}
      className="action-tray-link"
    >
      <FontAwesomeIcon icon={getIcon(props.icon)} />
      &nbsp;
      {props.children}
    </a>
  );
};

export default ModalIconLink;
